import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { CoreI18nConfigs } from "@core/configs/i18n.config";
import { AnagraficaService } from "@shared/services/anagrafica.service";
import { UtilsService } from "@shared/services/utils.service";

@Component({
  selector: "app-pages-gestione-anagrafica-crea-anagrafica",
  templateUrl: "./crea-anagrafica.component.html",
})
export class PagesGestioneAnagraficaCreaAnagraficaComponent implements OnInit {
  public criteriaForm: FormGroup;

  constructor(
    private anagraficaService: AnagraficaService,
    private utilsService: UtilsService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    this.criteriaForm = this.fb.group({
      descrizione: [null, Validators.required],
      siglaLegge: this.fb.control(null),
    });
  }

  public inserisciLegge() {
    if (this.criteriaForm.get("descrizione")?.invalid)
      this.utilsService.showWarning("Inserire una descrizione");
    else {
      this.anagraficaService
        .insertLegge(this.criteriaForm.getRawValue())
        .subscribe((response) => {
          this.utilsService.showSuccess(
            CoreI18nConfigs.messages.genericSuccess
          );
          this.router.navigate(["../ricerca"], { relativeTo: this.route });
        });
    }
  }
}
